<template>
  <component :is="layout" />
</template>

<script setup>
import { computed, defineProps } from 'vue'

import Nonav from '@/layouts/no-nav.vue'
import Default from '@/layouts/default.vue'
import Sidenav from '@/layouts/side-nav.vue'
import LogoOnly from '@/layouts/logo-only.vue'

const props = defineProps({
  name: {
    type: String,
    default: ''
  },
})

const layout = computed(() => {
  const map = {
    'no-nav': Nonav,
    default: Default,
    'side-nav': Sidenav,
    'logo-only': LogoOnly
  }
  return map[props.name?.toLowerCase()] || Nonav
})
</script>
